/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const liveSearchProductsObserver = {
    observer: null,
    firstLoadedProductSelector: "#product-list > [data-page]",
    /**
     * Get the page number from the element.
     * @param {HTMLElement} element
     * @returns {number}
     */
    getPageNumberFromElement(element) {
        return parseInt(element.dataset.page) || 1;
    },
    /**
     * Observe the products to update the URL when the user scrolls to a new page.
     */
    observeProducts() {

        if (this.observer) {
            this.observer.disconnect();
        }

        const pageIndicators = document.querySelectorAll(this.firstLoadedProductSelector);
        if (pageIndicators.length === 0) return;

        this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const observedPage = this.getPageNumberFromElement(entry.target);
                if (entry.isIntersecting) {
                    this.setUrlPageParam(observedPage);
                } else if (
                    entry.boundingClientRect.top > 0
                    && observedPage > 1
                    && pageIndicators.length > 1
                ) {
                    this.setUrlPageParam(observedPage - 1);
                }
            });
        }, { rootMargin: "0px", threshold: 0.5 });

        pageIndicators.forEach(product => {
            this.observer.observe(product);
        });
    }
}

export default liveSearchProductsObserver;
